module.exports = __webpack_public_path__ + "img/frame (8).8103e4e5.jpg";